import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { triggerAnchorClick } from "../utils";
export function doOpenUrlForOther(targetUrl, options, currentWindow) {
  var replace = options.replace,
      noHistory = options.noHistory,
      safariNeedReplace = options.safariNeedReplace,
      launchClient = options.launchClient; // 包括非 IE 的普通浏览器，还有 ipad,iphone 下的 safari，还有腾讯文档APP，微云APP，以及其他尚未考虑到的场景

  var jumpUrl = targetUrl;

  try {
    if (jumpUrl.startsWith('//')) {
      jumpUrl = "".concat(location.protocol).concat(jumpUrl);
    }

    var urlObj = new URL(jumpUrl);
    /** nlc: no launch client */

    var key = 'nlc';

    if (urlObj.hostname === 'docs.qq.com' && !launchClient) {
      urlObj.searchParams.set(key, '1');
      jumpUrl = urlObj.toString();
    }
  } catch (e) {
    console.error('parse url params error:', e);
  }

  if (safariNeedReplace) {
    currentWindow.location.href = jumpUrl;
    return;
  } // 先处理打开新窗口的情况


  if (ensureOpenNewWindow(_objectSpread(_objectSpread({}, options), {}, {
    url: jumpUrl
  }))) {
    return;
  }

  var a = document.createElement('a');
  a.href = jumpUrl;

  if (replace) {
    a.target = '_self';
  } else {
    a.target = '_blank'; // 核心，断掉referrer，用多线程，减少卡顿

    a.rel = 'noreferrer';
  }

  if (noHistory) {
    // 跳转后不留history
    history.replaceState(null, document.title, jumpUrl);
  }

  triggerAnchorClick(a);
} // 当windowName和windowFeatures皆传入时，需要打开新窗口，不能使用a标签处理

function ensureOpenNewWindow(options) {
  var url = options.url,
      windowName = options.windowName,
      windowFeatures = options.windowFeatures;

  if (windowName && windowFeatures) {
    window.open(url, windowName, windowFeatures);
    return true;
  }

  return false;
}